import { createContext, useContext, useState, ReactNode } from 'react'

interface TreasuryBalanceContextType {
  treasuryBalance: bigint | null
  setTreasuryBalance: (balance: bigint | null) => void
}

const TreasuryBalanceContext = createContext<
  TreasuryBalanceContextType | undefined
>(undefined)

export function TreasuryBalanceProvider({ children }: { children: ReactNode }) {
  const [treasuryBalance, setTreasuryBalance] = useState<bigint | null>(null)

  return (
    <TreasuryBalanceContext.Provider
      value={{ treasuryBalance, setTreasuryBalance }}
    >
      {children}
    </TreasuryBalanceContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTreasuryBalance() {
  const context = useContext(TreasuryBalanceContext)
  if (context === undefined) {
    throw new Error(
      'useTreasuryBalance must be used within a TreasuryBalanceProvider'
    )
  }
  return context
}
